<nav class="grid navbar container py-1 text-white">
  <div class="col-12 flex justify-content-end align-items-center w-full">
    <div class="open-menu-icon" (click)="menuToggle = !menuToggle">
      <i class="pi pi-bars"></i>
    </div>
    <div
      class="flex align-items-center nav-links"
      [ngClass]="{ 'open-menu': menuToggle }"
    >
      <span
        class="cursor-pointer uppercase ml-3 font-medium nav-link"
        *ngFor="let route of routes"
        (click)="onNavigate(route.path)"
        routerLinkActive="text-blue-300"
      >
        {{ route.title }}
      </span>
      <div class="flex align-items-center user-info">
        <p-avatar
          shape="circle"
          styleClass="text-black-alpha-90 ml-4 mr-2"
          [label]="userData?.name[0]"
        ></p-avatar>
        <strong> {{ userData?.name }} </strong>
      </div>
      <div class="close-icon" (click)="menuToggle = !menuToggle">
        <i class="pi pi-times"></i>
      </div>
    </div>
  </div>
</nav>

<!-- * Message -->
<p-toast position="top-center" key="br" styleClass="mt-8"> </p-toast>

<!-- * Warn message -->
<p-toast position="top-center" key="br-warn" styleClass="mt-8"></p-toast>

<!-- * Error message -->
<p-toast position="top-center" key="br-error" styleClass="mt-8"></p-toast>
